import { Grid } from '@change/ds-layout/Grid';

import { BackToDashboard } from '../components/BackToDashboard';
import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageHeading } from '../components/PageHeading';
import { PetitionUpdateStaffDrawer } from '../components/PetitionUpdateStaffDrawer';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	return (
		<>
			<BackToDashboard />
			<Grid className="px-0">
				<div className="col-span-full mx-4 mt-3 flex flex-col gap-8">
					<PageBanner />
					<PageHeading />
					<PageBody />
				</div>
				<PageFooter />
			</Grid>
			<PetitionUpdateStaffDrawer />
		</>
	);
};
